import { render, staticRenderFns } from "./newseltos-out-inner.vue?vue&type=template&id=27d47f02&scoped=true"
import script from "./newseltos-out-inner.vue?vue&type=script&lang=js"
export * from "./newseltos-out-inner.vue?vue&type=script&lang=js"
import style0 from "./newseltos-out-inner.vue?vue&type=style&index=0&id=27d47f02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d47f02",
  null
  
)

export default component.exports